export default __webpack_public_path__ + "static/media/Ballroll_00191.eb104ae4.png";